import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getAllReportsData } from "../../../../utils/apis/Inward/Inward";
import Pagination from "../../../common/Pagination";
import { formatDate } from "../../../../utils/common";
import ScreenShot from "../../../common/ScreenShot";
import { Context } from "../../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditAmount from "../../../common/EditAmont";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import FilterOffcanvas from "../../../common/common-offcanvas/Filter_offcanvas";
import { Modal } from "react-bootstrap";
import { Permission } from "../../../../utils/permissions";

const Reports = ({
  status,
  setStatus,
  handleExportCSV,
  handlePrint,
  handleExportExcel,
  isAllow,
  convertrate,
}) => {
  const { IMG_URL } = useContext(Context);
  const { register, reset, setValue, control, getValues } = useForm();


  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [modalShow, setModalShow] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [inwardID] = useState(false);
  const [previousAmount] = useState("");

  const getData = async () => {
    const res = await getAllReportsData(
      currentPage,
      perPage,
      getValues("contact"),
      getValues("name"),
      getValues("from"),
      getValues("to"),
      getValues("state_id")?.value,
      getValues("city_id")?.value,
      getValues("bank_account_id")?.value,
    );
    setData(res.data);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setTotalEntries(res?.data?.totalEntries);
    setTotalPages(res?.data?.totalPages);
  };

  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perPage, currentPage, status]);
  const [modalShow2, setModalShow2] = React.useState(false);

  return (
    <div className="search-investor mt-4">
      <p className="sub">Report</p>

      {isAllow?.includes(Permission.InwardPayment.Download.name) ? (
        <div className="inward-payment">
          <div className="nav-link active">
            <div className="dt-buttons btn-group flex-wrap">
              <button
                className="btn btn-secondary buttons-excel buttons-html5 ml-1 Excel_btn"
                tabindex="0"
                type="button"
                onClick={() => handleExportExcel(data, "Report")}
              >
                <span>Excel</span>
              </button>
              <button
                className="btn btn-secondary buttons-csv buttons-html5 CSV_btn"
                tabindex="0"
                type="button"
                onClick={() => handleExportCSV(data, "Report")}
              >
                <span>CSV</span>
              </button>
              <button
                className="btn btn-secondary buttons-print Print_btn"
                tabindex="0"
                type="button"
                onClick={() => handlePrint(data, "Report")}
              >
                <span>Print</span>
              </button>

              <input
                type="number"
                className="ps-3"
                onChange={(e) => setperPage(e.target.value)}
                placeholder="Enter Per Page Data"
              ></input>
            </div>
          </div>
          <div className="filterdiv">
            <button onClick={() => setModalShow2(true)} className="filterbtn">
              <FontAwesomeIcon icon={faFilter} />
              &nbsp;Filter
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* table started */}
      <div className="table-main">
        <div className="table-responsive mt-2">
          <table className="table table-bordered  table-striped">
            <thead>
              <tr>
                <th className="name">
                  Payment Date
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Investor Name
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Service No
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Bank Name
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  UTR ID
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Screenshot
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Amount
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Status
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                {/* <th className="name">
                  Action
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}
              </tr>
              {/* )} */}
            </thead>
            <tbody>
              {data?.data?.map((data, index) => (
                <tr className="odd" key={index}>
                  <td>{formatDate(data?.createdAt)}</td>
                  <td>
                    {data?.user?.f_name} {data?.user?.l_name}
                  </td>
                  <td>{data?.user?.contact_no}</td>
                  <td>
                    {data?.bank_account ? (
                      <>
                        {data?.bank_account?.network_id
                          ? `${data?.bank_account?.network?.name || ""} ${
                              data?.bank_account?.network?.sub_name || ""
                            }`.trim()
                          : `${data?.bank_account?.bank_name || ""} ${
                              data?.bank_account?.firm_name || ""
                            }`.trim()}
                      </>
                    ) : (
                      <>{data?.upi_id || "-"}</>
                    )}
                  </td>
                  <td>{data?.utr_id}</td>
                  <td>
                    <button
                      className="btn btn-info"
                      type="button"
                      onClick={() => setShowModal(data?.id)}
                    >
                      View Screenshot
                    </button>
                    <Modal
                      show={String(showModal) === String(data?.id)}
                      onHide={() => setShowModal(false)}
                      centered
                      size="lg"
                    >
                      <Modal.Body className="text-center">
                        <img
                          src={IMG_URL + data?.screenshot}
                          alt="Screenshot"
                          style={{
                            width: "100%",
                            maxHeight: "80vh",
                            objectFit: "contain",
                          }}
                        />
                      </Modal.Body>
                    </Modal>
                  </td>
                  <td>
                    ₹ <b>{convertrate(data?.amount)} </b>
                  </td>
                  <td>{data?.accepted_rejected ? "Accepted" : "Rejected"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* table ended */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        TotalPages={TotalPages}
        TotalEntries={TotalEntries}
        perPage={perPage}
      />

      <ScreenShot show={modalShow} onHide={() => setModalShow(false)} />
      <EditAmount
        show={editModal}
        onHide={() => setEditModal(false)}
        inwardID={inwardID}
        getData={getData}
        previousAmount={previousAmount}
      />

      {["end"].map((placement, idx) => (
        <FilterOffcanvas
          placement={placement}
          key={idx}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          setValue={setValue}
          getValues={getValues}
          getData={getData}
          register={register}
          reset={reset}
          control={control}
        />
      ))}
    </div>
  );
};

export default Reports;
